import React from 'react';

import styled from '@emotion/styled';

import { Spinner } from '@portal/components/helpers';
import { RenewalBanner } from '@portal/components/renewals/banner';
import { CONTAINER_SIDE_PADDING } from '@portal/components/shared/layout';
import { useAccountDetailQuery } from '@portal/schema';

import { View } from './view';

const Container = styled.div`
  padding: 0 ${16 - CONTAINER_SIDE_PADDING}px;
`;

export const Details: React.FC = () => {
  const { data, loading } = useAccountDetailQuery();

  if (loading) return <Spinner />;
  if (!data) return null;

  const { account, upcomingStorageOnboarding, renewalPackages } = data;

  return (
    <Container>
      <RenewalBanner packages={renewalPackages} />
      <View account={account} onboarding={upcomingStorageOnboarding} />
    </Container>
  );
};
